var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { useCallback, useState } from "react";
var getRightValue = function (str) { return (/\d/.test(str) ? str : ""); };
export var useOtpInput = function (props) {
    var length = props.length, onChangeOTP = props.onChangeOTP;
    var _a = useState(0), activeInput = _a[0], setActiveInput = _a[1];
    var _b = useState(Array(length).fill("")), otpValues = _b[0], setOTPValues = _b[1];
    var handleOtpChange = useCallback(function (otp) {
        var otpValue = otp.join("");
        onChangeOTP(otpValue);
    }, [onChangeOTP]);
    var changeCodeAtFocus = useCallback(function (str) {
        var updatedOTPValues = __spreadArrays(otpValues);
        updatedOTPValues[activeInput] = str[0] || "";
        setOTPValues(updatedOTPValues);
        handleOtpChange(updatedOTPValues);
    }, [activeInput, handleOtpChange, otpValues]);
    var focusInput = useCallback(function (inputIndex) {
        var selectedIndex = Math.max(Math.min(length - 1, inputIndex), 0);
        setActiveInput(selectedIndex);
    }, [length]);
    var focusPrevInput = useCallback(function () {
        focusInput(activeInput - 1);
    }, [activeInput, focusInput]);
    var focusNextInput = useCallback(function () {
        focusInput(activeInput + 1);
    }, [activeInput, focusInput]);
    var handleOnFocus = useCallback(function (index) { return function () {
        focusInput(index);
    }; }, [focusInput]);
    var handleOnChange = useCallback(function (e) {
        var val = getRightValue(e.currentTarget.value);
        if (!val) {
            e.preventDefault();
        }
        else {
            changeCodeAtFocus(val);
            focusNextInput();
        }
    }, [changeCodeAtFocus, focusNextInput]);
    var onBlur = useCallback(function () {
        setActiveInput(-1);
    }, []);
    var handleOnKeyDown = useCallback(function (e) {
        if (e.key === "Backspace" || e.key === "Delete") {
            otpValues[activeInput] ? changeCodeAtFocus("") : focusPrevInput();
        }
        else if (e.key === "ArrowLeft") {
            focusPrevInput();
        }
        else if (e.key === "ArrowRight") {
            focusNextInput();
        }
    }, [activeInput, changeCodeAtFocus, focusNextInput, focusPrevInput, otpValues]);
    return {
        activeInput: activeInput,
        handleOnChange: handleOnChange,
        handleOnFocus: handleOnFocus,
        handleOnKeyDown: handleOnKeyDown,
        onBlur: onBlur,
        otpValues: otpValues,
    };
};
